import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import Button from '@material-ui/core/Button';
import { navigate } from '@reach/router';
import { ADMIN_SHOP_VARIANTS } from '../../../gql/admin-queries';
import { ADMIN_CREATE_VARIANT } from '../../../gql/admin-mutations';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing,
    marginRight: theme.spacing
  }
});

class AddVariant extends Component {
  state = {
    name: ''
  };

  render() {
    const { shopId } = this.props;
    return (
      <div>
        <Mutation
          mutation={ADMIN_CREATE_VARIANT}
          variables={{ shopId }}
          update={(cache, { data: { createVariant } }) => {
            if (createVariant.id) {
              navigate(
                `/admin/${shopId}/inventory/variants/${createVariant.id}`
              );
              const data = cache.readQuery({
                query: ADMIN_SHOP_VARIANTS,
                variables: { id: shopId }
              });
              data.shop.attributes.edges.unshift({
                node: {
                  ...createVariant
                },
                __typename: 'ShopVariantEdge'
              });
              cache.writeQuery({
                query: ADMIN_SHOP_VARIANTS,
                variables: { id: shopId },
                data
              });
            }
          }}
        >
          {addVariant => (
            <Button
              data-cy="Variant-Add-New-btn"
              color="primary"
              onClick={addVariant}
              variant="outlined"
            >
              New Variant
            </Button>
          )}
        </Mutation>
      </div>
    );
  }
}

export default withStyles(styles)(AddVariant);
